import Service from "../../../Services/index";
import moment from "moment"

const WorkScheduleEmployee = {
    namespaced: true,
    state: {
        workScheduleList:[],
        work_schedule:{
            id:"",
            employee : "",
            leave_type : "",
            start_date : "",
            end_date : "",
            status : "",
            time : "",
            leave_time : "",
            employee_id : '',
            leave_time_type :""
        },
        work_schedule_employee : [],
        search:{
            employee_type: "",
            position : "",
            employee : '',
            date : [],
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
    },
    mutations: {
        GET_WORK_SCHEDULE_EMPLOYEE: (state, res) => {
            state.workScheduleList = res.data;
            state.dataPaginate = {
                current_page : res.current_page,
                from : res.form,
                last_page : res.last_page,
                per_page : res.per_page,
                total : res.total,
                to : res.to
            };
        },
        GET_WORK_SCHEDULE_BY_ID:(state,res)=>{
            console.log(res);
            state.work_schedule = res;
        },
        GET_EMPLOYEE:(state,res)=>{
            state.employee = res;
        },
        CLEAR_DATA: (state , employee)=>{
            state.work_schedule = {
                id: "",
                employee : employee,
                leave_type : "",
                start_date : "",
                end_date : "",
                status : "",
                time : "",
                leave_time_type : "",
            }
        },
        CLEAR_SEARCH: (state)=>{
            state.search = {
                employee_type: "",
                type_id: "",
                position: "",
                position_id: "",
                employee : '',
                date : [],
            }
        },
        GET_WORK_SCHEDULE_BY_EMPLOYEE : (state,res)=>{
            state.work_schedule_employee = res.data;
            state.dataPaginate = {
                current_page : res.current_page,
                from : res.form,
                last_page : res.last_page,
                per_page : res.per_page,
                total : res.total,
                to : res.to
            };
        }
    },
    actions: {
        setWorkScheduleList({commit},page=1){
            return Service.WorkScheduleEmployee.getWorkScheduleEmployee(page).then(response => {
                commit("GET_WORK_SCHEDULE_EMPLOYEE", response);
            });
        },
        showWorkScheduleById({commit},id){
            return Service.WorkScheduleEmployee.showWorkScheduleEmployee(id)
                .then(res=>{
                    commit("GET_WORK_SCHEDULE_BY_ID",res);
                })
        },
        saveWorkSchedule({commit},{id,data}){
            if(!id){
                return Service.WorkScheduleEmployee.createWorkScheduleEmployee(data)
                    .then(res=>{
                        commit("GET_WORK_SCHEDULE_BY_ID",res);
                    })
            }else{
                return Service.WorkScheduleEmployee.updateWorkScheduleEmployee(id,data)
                    .then(res=>{
                        commit("GET_WORK_SCHEDULE_BY_ID",res);
                    })
            }
        },
        showWorkScheduleByEmployee({commit},id){
            return Service.WorkScheduleEmployee.showWorkScheduleByEmployee(id).then(res=>{
                commit("GET_WORK_SCHEDULE_BY_EMPLOYEE",res);
            });
        },
        delete({commit},id){
            return Service.WorkScheduleEmployee.deleteWorkScheduleEmployee(id);
        },
        searchEmployeeWorkSchedule({commit},data){
            return Service.WorkScheduleEmployee.searchEmployeeWorkSchedule(data).then(res=>{
                commit("GET_WORK_SCHEDULE_EMPLOYEE", res);
            })
        },
        clearData({commit},employee){
            commit("CLEAR_DATA",employee)
        },
        clearSearch({commit}){
            commit("CLEAR_SEARCH");
        }
    }
};
export default WorkScheduleEmployee;
